import { render } from "./CreatedProjects.vue?vue&type=template&id=1ec1cf9e"
import script from "./CreatedProjects.vue?vue&type=script&lang=js"
export * from "./CreatedProjects.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__